
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

// Reactivate a reagent that was previously removed
export const reactivateReagent = async (reagentId: string): Promise<boolean> => {
  try {
    // Get current user
    const { data: sessionData } = await supabase.auth.getSession();
    if (!sessionData.session) {
      toast.error("You must be logged in to reactivate a reagent");
      return false;
    }

    const userId = sessionData.session.user.id;
    
    // Update the reagent to set available = true to reactivate it
    const { error } = await supabase
      .from("reagents")
      .update({ available: true })
      .eq("id", reagentId)
      .eq("user_id", userId);

    if (error) {
      console.error("Error reactivating reagent:", error);
      toast.error("Failed to reactivate reagent");
      return false;
    }

    toast.success("Reagent reactivated successfully");
    return true;
  } catch (error) {
    console.error("Exception in reactivateReagent:", error);
    toast.error("An unexpected error occurred");
    return false;
  }
};
